import { cssCustomPropPrefix } from '@polestar/component-warehouse-react/helpers/style';
export const createCustomLetterSpacing = (multiplier) => `${multiplier}rem`;
/**
 * @internal
 */
export const letterSpacingsValues = {
    ltr: {
        small: createCustomLetterSpacing(-0.01875),
        large: createCustomLetterSpacing(-0.075),
    },
    rtl: {
        small: 0,
        large: 0,
    },
};
var LettersSpacingCSSCustomProps;
(function (LettersSpacingCSSCustomProps) {
    LettersSpacingCSSCustomProps["large"] = "--cw-letter-spacing-large";
    LettersSpacingCSSCustomProps["small"] = "--cw-letter-spacing-small";
})(LettersSpacingCSSCustomProps || (LettersSpacingCSSCustomProps = {}));
/**
 * @internal
 */
export var LetterSpacingsTokens;
(function (LetterSpacingsTokens) {
    LetterSpacingsTokens["large"] = "var(--cw-letter-spacing-large, 0)";
    LetterSpacingsTokens["small"] = "var(--cw-letter-spacing-small, 0)";
})(LetterSpacingsTokens || (LetterSpacingsTokens = {}));
const LetterSpacings = {
    ...LetterSpacingsTokens,
    customProps: {
        ...LettersSpacingCSSCustomProps,
    },
};
export default LetterSpacings;
